import { useDispatch } from 'react-redux'

import { parseError } from '../helpers/errors'
import { showErrorBanner } from '../redux/actions/ui/actions'

export function useErrorMessage() {
  const dispatch = useDispatch()

  return function errorMessage(e: any) {
    if (e?.message && !e.message.toLowerCase?.().includes('request failed')) {
      return dispatch(showErrorBanner({ message: e.message, title: e.title }))
    }
    dispatch(showErrorBanner({ message: parseError(e) }))
  }
}
